import { useFormContext } from 'react-hook-form'
import useT from '@hooks/useTranslation'

import styles from 'styles/validation/Error.module.css'

const Error = ({ name }) => {
    const { formState: { errors }} = useFormContext()
    const error = errors[name]

    return error
        ? <ErrorMessage error={error} />
        : null
}

function ErrorMessage ({ error: { message }}) { // type
    return (
        <div className={styles.err} data-type="error">
            {useT(message || 'Popraw pole')}
        </div>
    )
}

export default Error